import { computed, observable, makeObservable } from 'mobx';

import origins from '../fixedData/origins';
import { IAccess } from '../models/access';
import { IPlace } from '../models/place';
import { IResort } from '../models/resort';

export default class ByAccess {
  @observable public showMap: boolean = false;
  @observable public access: IAccess = { path: [], duration: null };
  @observable public duration: number = 180;
  @observable public isLoading: boolean = false;
  @observable public mapCenter: { lat: number, lng: number } = { lat: 35.6811673, lng: 139.7670516 };
  @observable public openIndex: number = null;
  @observable public originIndex: number = 0;
  @observable public origins: Array<IPlace> = origins;
  @observable public resorts: Array<IResort> = [];
  @observable public update: () => void = () => {};
  @observable public updateAccess: ({ origin_id, dest_id }: { origin_id: string, dest_id: string }) => void
    = () => {};

  constructor() {
    makeObservable(this);
  }

  @computed get currentOrigin(): IPlace {
    return this.origins[this.originIndex];
  }

  @computed get durationInHour(): number {
    const { duration } = this.access;
    return duration ? Number((duration / 60).toFixed(1)) : null;
  }

  @computed get resortListPath(): string {
    return `/snow/searches?access[place_id]=${this.currentOrigin.place_id}&access[duration]=${this.duration}`;
  }
}
